import { useEffect, useRef, useState } from "react";

export function useTypewriter(text: string, speed = 15) {
  const [output, setOutput] = useState("");
  const [done, setDone] = useState(false);
  const indexRef = useRef(0);

  useEffect(() => {
    setOutput("");
    setDone(false);
    indexRef.current = 0;

    const timer = setInterval(() => {
      setOutput(text.slice(0, indexRef.current + 1));
      indexRef.current += 1;

      if (indexRef.current >= text.length) {
        clearInterval(timer);
        setDone(true);
      }
    }, speed);

    return () => clearInterval(timer);
  }, [text, speed]);

  return { output, done };
}